import { getApiDomainFromHostname, reassignUrlDomain } from '@percent/utility'
import { env } from '@percent/admin-dashboard/env'

export const environment = env.NX_PUBLIC_REACT_APP_ENV
const DEFAULT_TEST_API_URL = 'https://localhost:8080/'
const DEFAULT_TEST_APP_URL = 'https://localhost:3000'

const envConfig = (() => {
  const obj = {
    urls: {
      api: '',
      app: ''
    },
    keys: {
      ga: '',
      client_id: '',
      recaptchaSiteKey: env.NX_PUBLIC_RECAPTCHA_SITE_KEY ?? ''
    },
    donation: {
      donationRequestPreviewUrl: ''
    },
    disbursement: {
      disbursementPreviewUrl: ''
    },
    donationMatchRequest: {
      dashboardLink: ''
    }
  }

  const appDomain = getApiDomainFromHostname()

  obj.disbursement.disbursementPreviewUrl = env.NX_PUBLIC_DISBURSEMENT_PREVIEW_URL
  obj.donation.donationRequestPreviewUrl = env.NX_PUBLIC_DONATION_REQUEST_PREVIEW_URL
  obj.donationMatchRequest.dashboardLink = env.NX_PUBLIC_DONATION_MATCH_REQUEST_URL

  if (env.NX_PUBLIC_TEST_MODE === true || env.NX_TEST_MODE === true) {
    obj.urls.api = `${DEFAULT_TEST_API_URL}`
    obj.urls.app = `${DEFAULT_TEST_APP_URL}`
  } else if (env.NX_PUBLIC_API_URL_VERBATIM === true) {
    // Pairing this app with a locally-run pbp-api. reassignUrlDomain below swaps the
    // last two labels of the API hostname for the domain the app is served from, and
    // falls back to goodstack.io for anything unrecognised - so `http://localhost:8080`
    // comes out as `http://goodstack.io:8080` and a local API is unreachable. Opting out
    // keeps both on localhost, which also keeps the session cookie first-party (it is
    // SameSite=Lax, and the port is not part of the site).
    // Trailing slash stripped first, as reassignUrlDomain does on the other branch - without
    // it an API URL supplied with one yields a `//` base and double-slashed request paths.
    obj.urls.api = `${env.NX_PUBLIC_API_URL.replace(/\/+$/, '')}/`
    obj.urls.app = `${env.NX_PUBLIC_APP_URL.replace(/\/+$/, '')}`
  } else {
    obj.urls.api = `${reassignUrlDomain(env.NX_PUBLIC_API_URL, appDomain)}/`
    obj.urls.app = `${reassignUrlDomain(env.NX_PUBLIC_APP_URL, appDomain)}`
  }

  return obj
})()

export const config = {
  ...envConfig,
  version: '1.0.0'
}
